/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid7443IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid7443Icon(props: Xmlid7443IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 114 414"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M112.635 366.498c-1.708 16.447-5.919 30.139-9.507 39.396-2.728 7.004-10.951 10.01-17.52 6.368l-7.667-4.263q.636-.972 1.073-2.105c3.602-9.257 7.813-22.949 9.52-39.396 4.197-40.307-8.421-77.889-36.48-108.689-28.55-31.317-20.671-47.392-3.404-82.589 6.78-13.838 14.46-29.516 19.44-47.3 6.527-23.371 5.177-59.522-38.336-98.996C19.452 19.589 8.726 11.882 0 6.2 3.417.242 11.11-1.823 17.042 1.778c9.495 5.747 23.504 15.082 36.812 27.146C97.38 68.398 98.717 104.549 92.19 127.92c-4.965 17.784-12.659 33.463-19.439 47.3-17.254 35.197-25.133 51.272 3.403 82.589 28.06 30.8 40.68 68.38 36.482 108.689z"
        }
      ></path>
    </svg>
  );
}

export default Xmlid7443Icon;
/* prettier-ignore-end */
